/* eslint-disable react/no-array-index-key */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
/* eslint-disable no-param-reassign */
/* eslint-disable func-names */
/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  Grid,
  Box,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ShortTextIcon from '@mui/icons-material/ShortText';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import TodayIcon from '@mui/icons-material/Today';
import CakeIcon from '@mui/icons-material/Cake';
import PeopleIcon from '@mui/icons-material/People';
import AddIcon from '@mui/icons-material/Add';
import Radio from '@atoms/Radio';
import TextField from '@atoms/TextField';
import DateTimePicker from '@atoms/DateTimePicker';
import Typography from '@atoms/Typography';
import Image from '@atoms/Image';
import CustomDialog from '@app/components/molecules/CustomDialog';

import PhoneInput from '@molecules/PhoneInput';
import { FIELDS_ENUM, SUBTYPE_ENUM } from '@app/constants';
import { getPickerFormat } from '@app/helpers';
import { useTranslation } from '@app/config/i18n';

import BorderButton from '@app/components/atoms/BorderButton';
import {
  AccordionBoxes,
  useClasses,
  GroupMembersField,
  StyledAccordion,
  StyledPhoneInput,
  StyledFieldView,
} from './style';
import { ErrorList } from '../FormBodyV2/style';

const gridSizes = { lg: 12, md: 12, sm: 12, xs: 12 };

// eslint-disable-next-line react/prop-types
const GroupMembers = ({ groupField, minAge, maxAge, members, setMembers, name, id, preview }) => {
  const { t } = useTranslation(['wizard', 'dashboard', 'common', 'applications']);
  const classes = useClasses();
  const [modalOpened, setModalOpened] = useState(false);
  const [tempMember, setTempMember] = useState(null);
  const [editedIndex, setEditedIndex] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [ageError, setAgeError] = useState('');

  const tableRef = React.useRef(null);

  const memberFields = groupField.child_fields;

  const fieldsMap = useMemo(
    () =>
      groupField &&
      groupField.child_fields &&
      groupField.child_fields.reduce((carry, { id, label, type }) => {
        carry[id] = { label, type };
        return carry;
      }, {}),
    [groupField]
  );

  const clearTemp = () => {
    let newTemp = [];
    memberFields.forEach((field) => {
      let defaultValue = '';
      if (field.type === FIELDS_ENUM.DATETIME_FIELD || field.type === FIELDS_ENUM.LIST) {
        defaultValue = null;
      }
      if (field.type === FIELDS_ENUM.TOGGLE) {
        defaultValue = false;
      }
      newTemp = [...newTemp, { field: field.id, value: defaultValue, group_idx: members.length }];
    });
    setTempMember(newTemp);
  };

  useEffect(() => {
    if (memberFields && memberFields.length > 0 && !tempMember) {
      clearTemp();
    }
  }, [memberFields]);

  const handleDialogOpen = () => {
    setModalOpened(true);
  };

  const handleDialogClose = () => {
    setModalOpened(false);
  };

  const handleSaveMember = () => {
    let newMembers = members && members.length > 0 ? [...members] : [];

    // Validation
    let errors = [];
    tempMember?.forEach((elem) => {
      if (elem.value === '' || elem.value === null) {
        const field = memberFields.find((f) => f.id === elem.field);
        errors = [...errors, ` ${field.label}`];
      }
    });

    if (errors.length > 0) {
      setErrorMessage(
        `${t('common:validation.req')}: ${errors.map((err, index) =>
          index === 0 ? err : ` ${err}`
        )}  `
      );
    }

    if (errors.length === 0 && !ageError) {
      setErrorMessage('');
      setAgeError('');
      if (editedIndex !== null) {
        // Edit operation
        newMembers[editedIndex] = [...tempMember];
        setEditedIndex(null);
      } else {
        // Save new Operation
        newMembers = [...newMembers, tempMember];
      }

      setMembers(newMembers);
      handleDialogClose();
      clearTemp();
    }
  };

  const setFieldValue = (field, value) => {
    const newTemp = [...tempMember];
    const updatedField = newTemp.find((tempField) => tempField.field === field.id);
    if (updatedField) {
      updatedField.value = value;
    }
    setTempMember(newTemp);
  };

  const getFieldValue = (field) => {
    const selectedField =
      tempMember && tempMember.find((tempField) => tempField.field === field.id);
    return selectedField ? selectedField.value : null;
  };

  const textChangeHandler = (field) => (event) => {
    setFieldValue(field, event.target.value);
  };

  const phoneChangeHandler = (field) => (value) => {
    setFieldValue(field, value);
  };

  const getSelectValue = (list, val) => {
    if (!Array.isArray(val)) {
      return list.filter((listItem) => val.split(', ').includes(listItem.name));
    }
    return list.filter((listItem) => val.includes(listItem.id));
    // TODO: On multiple change the return to array
  };

  const dateChangeHandler = (field) => (e) => {
    if (e) {
      if (e.format('YYYY-MM-DD HH:mm:ss') && (minAge || maxAge)) {
        const age = moment().diff(e.format('YYYY-MM-DD HH:mm:ss'), 'years');

        if (age < minAge || age > maxAge) {
          setAgeError(`Members should be between the ages of ${minAge} and ${maxAge}`);
        } else {
          setAgeError('');
        }
      }
      setFieldValue(field, e.format('YYYY-MM-DD HH:mm:ss'));
    } else {
      setFieldValue(field, null);
    }
  };

  const checkboxChangeHandler = (field, isChecked) => () => {
    // setTempMember({ ...tempMember, [field]: !tempMember[field] });
    setFieldValue(field, !isChecked);
  };

  const editMemberHandler = (memberData, index) => () => {
    setEditedIndex(index);
    setTempMember(memberData);
    handleDialogOpen();
  };

  const deleteMemberHandler = (memberData) => () => {
    const newMembers = [...members];

    newMembers.splice(memberData, 1);

    setMembers(newMembers);
  };

  const getMemberFieldValue = (fieldId, value) => {
    switch (fieldsMap[fieldId].type) {
      case 'datetime_field':
        return moment(value).format('YYYY-MM-DD');
      case 'tel':
        return `+${value}`;
      case 'toggle':
        return t(`common:${value ? 'yes' : 'no'}`);
      default:
        return value.toString();
    }
  };

  const renderFields = (fields) => {
    return (
      fields &&
      fields.map((field) => {
        let fieldView = <></>;

        if (field.type === FIELDS_ENUM.TEXT_FIELD && field.subtype === SUBTYPE_ENUM.TEXT) {
          fieldView = (
            <Grid item {...gridSizes}>
              <TextField
                type="name"
                label={field.label}
                name={field.id}
                value={tempMember ? getFieldValue(field) : ''}
                onChange={textChangeHandler(field)}
                disabled={preview}
                required
                placeholder={field.label}
                InputProps={{
                  startAdornment: (
                    <InputAdornment>
                      <ShortTextIcon
                        color="secondary"
                        style={{ marginRight: '10px' }}
                        fontSize="small"
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          );
        } else if (field.type === FIELDS_ENUM.TEXT_FIELD) {
          fieldView = (
            <Grid item {...gridSizes}>
              <TextField
                type="name"
                label={field.label}
                name={field.id}
                value={tempMember ? getFieldValue(field) : ''}
                onChange={textChangeHandler(field)}
                disabled={preview}
                required
                placeholder={field.label}
                InputProps={{
                  startAdornment: (
                    <InputAdornment>
                      <ShortTextIcon
                        color="secondary"
                        style={{ marginRight: '10px' }}
                        fontSize="small"
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          );
        } else if (field.type === FIELDS_ENUM.EMAIL) {
          fieldView = (
            <Grid item {...gridSizes}>
              <TextField
                type="email"
                label={field.label}
                name={field.id}
                value={tempMember ? getFieldValue(field) : ''}
                onChange={textChangeHandler(field)}
                disabled={preview}
                required
                placeholder={field.label}
                InputProps={{
                  startAdornment: (
                    <InputAdornment>
                      <AlternateEmailIcon
                        color="secondary"
                        style={{ marginRight: '10px' }}
                        fontSize="small"
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          );
        } else if (field.type === FIELDS_ENUM.TEL) {
          fieldView = (
            <Grid item {...gridSizes}>
              <StyledPhoneInput>
                <Typography variant="caption" color="secondary" className="spanLabel">
                  {t('phone')}
                </Typography>
                <PhoneInput
                  value={tempMember ? getFieldValue(field) : ''}
                  onChange={phoneChangeHandler(field)}
                  disabled={preview}
                  label={null}
                  containerStyle={{
                    width: '100%',
                    height: '56px',
                  }}
                  inputStyle={{
                    width: '100%',
                    height: '56px',
                    paddingLeft: '80px',
                  }}
                  buttonStyle={{
                    padding: '10px',
                  }}
                />
              </StyledPhoneInput>
              {/*  <TextField
              type="phone"
              label={field.label}
              name={field.id}
              value={tempMember ? getFieldValue(field) : ''}
              onChange={textChangeHandler(field)}
              disabled={preview}
              placeholder={field.label}
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment>
                    <PhoneIcon color="secondary" style={{ marginRight: '10px' }} fontSize="small" />
                   
                  </InputAdornment>
                ),
              
              }}
            /> */}
            </Grid>
          );
        } else if (field.type === FIELDS_ENUM.DATETIME_FIELD) {
          fieldView = (
            <Grid item {...gridSizes}>
              <DateTimePicker
                onChange={dateChangeHandler(field)}
                id="deadline_date"
                name={field.id}
                // label={field.label}
                type={field.subtype}
                value={tempMember ? getFieldValue(field) : null}
                keyboardIcon={<TodayIcon color="primary" />}
                // format="yyyy/MM/dd HH:mm"
                format={getPickerFormat(field.subtype)}
                placeholder={t('wizard:group_members.birthday')}
                variant="inline"
                autoOk
                disabled={preview}
                InputProps={{
                  startAdornment: (
                    <InputAdornment>
                      <CakeIcon
                        color="secondary"
                        style={{ marginRight: '10px' }}
                        fontSize="small"
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          );
        } else if (field.type === FIELDS_ENUM.LIST && field.subtype === SUBTYPE_ENUM.RADIO) {
          fieldView = (
            <>
              <Grid item {...gridSizes}>
                {/* <Typography variant="body1" weight="600">
                {field.label}
              </Typography>

              <Box marginLeft="1rem" width="100%">
                <Radio.RadioGroup
                  aria-label="target"
                  name="target"
                  value={getFieldValue(field)}
                  onChange={textChangeHandler(field)}
                >
                  <Grid container>
                    {field.choices &&
                      field.choices.length > 0 &&
                      field.choices.map((choice) => (
                        <Grid item xs={6}>
                          <Radio
                            id="target"
                            label={choice}
                            value={choice}
                            color="primary"
                            inputProps={{
                              'aria-label': 'primary Radio',
                            }}
                            disabled={preview}
                          />
                        </Grid>
                      ))}
                  </Grid>
                </Radio.RadioGroup>
                          </Box> */}

                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="gender"> {t('wizard:group_members.gender')}</InputLabel>
                  <Select
                    labelId="gender"
                    label={t('wizard:group_members.gender')}
                    id="gender"
                    value={getFieldValue(field)}
                    onChange={textChangeHandler(field)}
                    startAdornment={
                      <InputAdornment position="start">
                        <Image
                          src="/images/icons/gender.svg"
                          width="24px"
                          height="24px"
                          color="secondary"
                        />
                      </InputAdornment>
                    }
                  >
                    {field.choices &&
                      field.choices.length > 0 &&
                      field.choices.map((name) => (
                        <MenuItem key={name} value={name} style={{ textTransform: 'capitalize' }}>
                          {name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            </>
          );
        } else if (field.type === FIELDS_ENUM.CORRESPONDING_AUTHOR) {
          const isChecked = tempMember && getFieldValue(field);
          fieldView = (
            <Grid item {...gridSizes}>
              {/* <Checkbox
              label={field.label}
              checked={isChecked}
              onChange={checkboxChangeHandler(field, isChecked)}
              value="true"
              color="primary"
              disabled={preview}
            /> */}
              <Typography variant="body2" color="secondary">
                Corresponding author
              </Typography>
              <Radio.RadioGroup
                aria-label="target"
                name={field.id}
                value={getFieldValue(field)}
                onChange={textChangeHandler(field)}
              >
                <Grid container direction="row" spacing="1">
                  <Grid item sm={12} lg={12} md={12} xs={12}>
                    <Radio
                      id="corresponding_author"
                      label="Yes"
                      value="yes"
                      color="primary"
                      inputProps={{
                        'aria-label': 'primary Radio',
                      }}
                      disabled={preview}
                    />
                    <Radio
                      id="corresponding_author"
                      label="No"
                      value="no"
                      color="primary"
                      inputProps={{
                        'aria-label': 'primary Radio',
                      }}
                      disabled={preview}
                    />
                  </Grid>
                </Grid>
              </Radio.RadioGroup>
            </Grid>
          );
        }

        return fieldView;
      })
    );
  };

  return (
    <Box marginBottom="0.5rem">
      <Grid container justify="center" spacing={5}>
        <Grid item {...gridSizes}>
          <BorderButton
            id={id}
            name={name}
            startIcon={<AddIcon />}
            variant="text"
            color="primary"
            onClick={handleDialogOpen}
          >
            {members.length === 0 ? 'Add author' : 'Add another author'}
          </BorderButton>
        </Grid>
        <Grid item {...gridSizes}>
          {members &&
            members.map((member, index) => (
              <StyledAccordion key={index}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <GroupMembersField>
                    <Box display="flex" alighItems="center">
                      <PeopleIcon fontSize="small" color="secondary" />
                      <Typography variant="subtitle1" color="secondary">
                        {member[0]?.value ? member[0]?.value.toString() : index}
                      </Typography>
                    </Box>
                    <Box display="flex" alighItems="center">
                      <DeleteIcon
                        fontSize="small"
                        color="primary"
                        className={classes.DeleteEditIcons}
                        onClick={deleteMemberHandler(index)}
                      />
                      <EditIcon
                        fontSize="small"
                        color="primary"
                        className={classes.DeleteEditIcons}
                        onClick={editMemberHandler(member, index)}
                      />
                    </Box>
                  </GroupMembersField>
                </AccordionSummary>
                <AccordionDetails>
                  {member &&
                    member.map(({ field, value }) => (
                      <AccordionBoxes key={field}>
                        <Typography variant="body1" className="boxTitle">
                          {fieldsMap[field].label} :
                        </Typography>
                        <Typography variant="subtitle1" color="secondary">
                          {getMemberFieldValue(field, value)}
                        </Typography>
                      </AccordionBoxes>
                    ))}
                </AccordionDetails>
              </StyledAccordion>
            ))}
        </Grid>
        {/*  {members && members.length > 0 && (
          <Grid item {...gridSizes}>
            <TableContainer>
              <MaterialTable
                tableRef={tableRef}
                title={t('dashboard:group_member_plural')}
                columns={columns}
                data={members}
                options={{
                  // selection: true,
                  // exportButton: true,
                  toolbarButtonAlignment: 'left',
                  showTextRowsSelected: false,
                  actionsColumnIndex: -1,
                }}
              />
            </TableContainer>
          </Grid>
              )} */}

        <CustomDialog
          open={modalOpened}
          onClose={handleDialogClose}
          title={t('Add author')}
          disabled={preview}
          cancelButtonText={t('common:cancel')}
          acceptButtonText={editedIndex !== null ? t('applications:save_author') : t('applications:add_author')}
          handleConfirm={handleSaveMember}
          classes={{ root: { padding: '20px' } }}
        >
          <Box style={{ paddingTop: '26px', paddingBottom: '26px' }}>
            {/* Render fields here */}

            <StyledFieldView container spacing={2}>
              {renderFields(memberFields)}
            </StyledFieldView>
            {errorMessage && <ErrorList>{errorMessage}</ErrorList>}
            {ageError && <ErrorList>{ageError}</ErrorList>}
          </Box>
        </CustomDialog>
      </Grid>
    </Box>
  );
};

GroupMembers.propTypes = {
  preview: PropTypes.bool,
};

GroupMembers.defaultProps = {
  preview: false,
};

export default GroupMembers;
